// extracted by mini-css-extract-plugin
module.exports = {"root":"site-page_root__qGv_L","content":"site-page_content__R1iGZ","mobile_no_margin":"site-page_mobile_no_margin__7i_B7","view":"site-page_view__hfr_b"};